
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.39 4.23755L10.065 2.43755C9.76498 2.13755 9.08998 1.98755 8.63998 1.98755H5.78998C4.88998 1.98755 3.91498 2.66255 3.68998 3.56255L1.88998 9.03755C1.51498 10.0875 2.18998 10.9875 3.31498 10.9875H6.31498C6.76498 10.9875 7.13998 11.3625 7.06498 11.8875L6.68998 14.2875C6.53998 14.9625 6.98998 15.7125 7.66498 15.9375C8.26498 16.1625 9.01498 15.8625 9.31498 15.4125L12.39 10.8375","stroke":"currentColor","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M16.215 4.2375V11.5875C16.215 12.6375 15.765 13.0125 14.715 13.0125H13.965C12.915 13.0125 12.465 12.6375 12.465 11.5875V4.2375C12.465 3.1875 12.915 2.8125 13.965 2.8125H14.715C15.765 2.8125 16.215 3.1875 16.215 4.2375Z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    